<script>
import wangeditor5 from "@/components/wangeditor5.vue";

export default {
  name: "chargeOrderForm",
  components: {wangeditor5},
  data() {
    let validateTime = (rule, value, callback) => {
      console.log(this.form.validityStartTime, this.form.validityEndTime);
      if (this.form.validityStartTime > this.form.validityEndTime) {
        console.log(4444);
        return callback(new Error('开始时间不得大于结束时间'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //设置选择今天之前的日期（不能选择当天）
        },
      },
      form: {
        organizationId: '',
        requirement: 1,
        validityStartTime: '',
        validityEndTime: '',
        activityExplain:'<p>·活动时间</p><p>具体时间以实际页面展示为准；</p><p>·活动玩法</p><p>本活动仅顺风车新车主（首单用户）可享</p><p>奖励金额以活动界面实际展示为准；</p><p>凡最后经平台认定用户存在违规作弊行为，我们有权取消用户获得奖励资格，且要求用户承担顺风车平台相应损失；</p><p>本活动由顺风车平台组织，有任何疑问请联系平台客服</p>'
      },
      rules: {
        coverImg: [{required: true, message: '请选择活动图片', trigger: 'change'}],
        activityExplain: [{required: true, message: '请输入活动说明', trigger: 'change'}],
        organizationId: [{required: true, message: '请选择机构名称', trigger: 'change'}],
        validityStartTime: [{
          required: true, message: '请选择开始时间', trigger: 'change',
        },
        ],
        validityEndTime: [
          {required: true, message: '请选择结束时间', trigger: 'change'},
          {validator: validateTime, trigger: ['blur', 'change']}
        ],
        activityAmount:
            [{required: true, message: '请输入首单奖励', trigger: 'change'}],
        prizePoolAmount:
            [{required: true, message: '请输入奖池金额', trigger: 'change'}],
      }
    }
  },
  async created() {
    await this.mixinOrganizations();
    this.form.organizationId = this.organizations[0].id;
  },
  methods: {
    imgClick(name) {
      this.$set(this.form, 'coverImg', name)

    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const url = '/api/v1/manage/hitchRide/activity'
          let params = {...this.form}
          params.validityStartTime = Math.floor(new Date(params.validityStartTime).setHours(0, 0, 0, 0) / 1000)
          params.validityEndTime = Math.floor(new Date(params.validityEndTime).setHours(0, 0, 0, 0) / 1000 + 60 * 60 * 24 - 1)
          const {code} = await this.$axios.post(url, params)
          if (code === 1) {
            this.$message.success('创建成功')
            this.$router.go(-1)
          }
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<template>
  <div class="chargeOrderForm" style="width: 500px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="机构名称" prop="organizationId">
        <el-select
            :disabled="mixinUserInfo.organizationType != 1"
            style="width: 100%;"
            v-model="form.organizationId"
            filterable
        >
          <el-option
              v-for="val in organizations"
              :key="val.id"
              :value="val.id"
              :label="val.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="validityStartTime">
        <el-date-picker :pickerOptions="pickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                        v-model="form.validityStartTime"
                        style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="validityEndTime">
        <el-date-picker :pickerOptions="pickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                        v-model="form.validityEndTime"
                        style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="活动条件" prop="requirement">
        <el-radio-group v-model="form.requirement">
          <el-radio :label="1">完成首单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="首单奖励" prop="activityAmount">
        <el-input v-input-filter="{min: 0.01, max: 100, precision: 2}" v-model="form.activityAmount">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="奖池金额" prop="prizePoolAmount">
        <div>
          <div>
            <el-input placeholder="请输入奖池金额" v-input-filter="{min: 0, max: 999999, precision: 2}"
                      v-model="form.prizePoolAmount">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div class="util-remark">奖池金额消耗完成即停止发放奖励</div>
        </div>
      </el-form-item>
      <el-form-item label="活动广告" prop="coverImg">
        <div>
          <div>
            <up-img @remove="$set(form, 'coverImg', '')" :file.sync="form.coverImg" width="343" height="77"></up-img>
          </div>
          <p class="util-remark">您可使用我们设计的广告封面，也可自行上传</p>
          <div>
            <img @click="imgClick('hd-cdjl.png')" style="height: 77px;width: 343px;cursor: pointer" :src="mixinQiniuImg('hd-cdjl.png')" alt="">
          </div>
        </div>
      </el-form-item>
      <el-form-item label="活动说明" prop="activityExplain">
        <wangeditor5 :height="200" :toolbarConfig="{toolbarKeys: []}"
                     :content.sync="form.activityExplain"></wangeditor5>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </el-form-item>

    </el-form>

  </div>

</template>

<style scoped lang="less">

</style>